import React, { useEffect, useState } from "react";

const Home = ({ openDrawer }) => {
  return (
    <div
      style={
        openDrawer
          ? {
              marginLeft: 240,
              width: "calc(100%-450px)",
              border: "2px solid green",
            }
          : { width: "calc(100%-200px)", border: "2px solid blue" }
      }
    >
      Welcome To Home DEP
    </div>
  );
};

export default Home;
